import { defineAgenda, param } from '@/shared/navigation/core';

/**
 * Agenda pro založení i editaci projektu (stejný formulář pro obojí).
 *
 * Bez `projectId` = režim založení; s `projectId` = režim editace existujícího projektu.
 * Otevírá se jako modální vrstva nad plánovací agendou.
 */
export const projectFormAgenda = defineAgenda({
  id: 'app.planner.project-form',
  path: 'app/planner/project',
  open: {
    projectId: param.uuid().optional(),
  },
  title: 'Projekt',
  icon: 'folder',
  presentationHints: {
    shell: {
      // Modální vrstva (otevírá se přes openModal); shell ji vykreslí jako overlay přes plánovací agendu.
      layoutMode: 'overlay',
    },
  },
});
